module.exports = __webpack_public_path__ + "img/gradient_fill.b02a8890.svg";